/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LocalReplyListContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer">;
    readonly " $refType": "LocalReplyListContainer_viewer";
};
export type LocalReplyListContainer_viewer$data = LocalReplyListContainer_viewer;
export type LocalReplyListContainer_viewer$key = {
    readonly " $data"?: LocalReplyListContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LocalReplyListContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '139e51227b7077281d4a97493fa9b3a5';
export default node;
